import React from 'react';
import { EngageProperties } from './EngageProperties';
import { EngageFlats } from './EngageFlats';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';

const Stack = createNativeStackNavigator<NavigationStacks[Stacks.Engage]>();

export const EngageScreen: React.FC<{ pageKey: string }> = ({ pageKey }) => {
  return (
    <Stack.Navigator
      initialRouteName={Screens.EngageProperties}
      screenOptions={{
        headerShown: false,
        animation: 'default',
      }}
    >
      <Stack.Screen
        name={Screens.EngageProperties}
        component={EngageProperties}
        initialParams={{ pageKey: pageKey }}
      ></Stack.Screen>
      <Stack.Screen name={Screens.EngageFlats} component={EngageFlats} />
    </Stack.Navigator>
  );
};
